// Shared shadow values for consistent elevation across the app
// Import: import { shadows } from '@/theme';

import { neutral } from './palette';

export const shadows = {
  // Elevated elements (dropdowns, tooltips, popovers)
  elevated: '0 4px 12px rgba(0, 0, 0, 0.15)',

  // Card hover/focus state
  card: '0 4px 12px rgba(0, 0, 0, 0.1)',

  // Subtle elevation (floating buttons, badges)
  subtle: '0 1px 3px rgba(0, 0, 0, 0.2)',

  // Button default state (subtle depth)
  buttonDefault: 'rgba(0, 0, 0, 0.02) 0 1px 3px 0',

  // Button hover state (lifted)
  buttonHover: 'rgba(0, 0, 0, 0.1) 0 4px 12px',

  // Button active/pressed state
  buttonActive: 'rgba(0, 0, 0, 0.06) 0 2px 4px',

  // App header shadow (matches AppShell header)
  header: '0 3px 8px 0 rgba(67, 79, 77, 0.45)',

  // Hover overlay buttons
  hoverOverlay: '0 5px 7px -3px rgba(0, 0, 0, 0.08), 0 12px 18px 1px rgba(0, 0, 0, 0.05), 0 4px 20px 4px rgba(0, 0, 0, 0.06)',

  // Menu item shadow
  menuItem: `0 3px 7px ${neutral.subtle}`,
} as const;
